import { BROADCAST_STATUS_FILTERS } from "../components/Broadcasts/BroadcastSidebar";

// Maps a campaign's backend status onto the sidebar filter it belongs under.
// CANCELLED has no distinct sidebar filter, so it's grouped with Failed.
export const BACKEND_STATUS_TO_FILTER_KEY = {
  PENDING: "draft",
  SCHEDULED: "scheduled",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  FAILED: "failed",
  CANCELLED: "failed",
};

const filtersByKey = new Map(BROADCAST_STATUS_FILTERS.map((f) => [f.key, f]));

// paletteKey is a MUI Chip `color` value (e.g. "success"/"warning"/"error"),
// matching how the same statuses render in BulkMessageHistoryModal.jsx.
export const getBroadcastStatusDisplay = (status) => {
  const filter = filtersByKey.get(BACKEND_STATUS_TO_FILTER_KEY[status]);
  return {
    label: filter?.label || status,
    paletteKey: filter?.paletteKey || "default",
  };
};
